import { Eye, ThumbsUp, Clock, Youtube, FileText, RotateCcw, Download, Share2, Check } from "lucide-react";
import ShareButtons from "../ShareButtons";

const formatNumber = (num) => {
  if (!num) return "0";
  if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
  if (num >= 1000) return (num / 1000).toFixed(1) + "K";
  return num.toString();
};
const formatDuration = (seconds) => {
  if (!seconds) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export default function ResultsTopBar({ analysis, shareMode, user, copied, onReset, onDownloadPdf, onShare }) {
  const vm = analysis.video_metadata;
  return (
    <div data-testid="results-toolbar" className="vt-glass rounded-2xl p-4 md:p-5 border border-white/10">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-4 min-w-0 flex-1">
          {vm?.thumbnail ? (
            <img src={vm.thumbnail} alt="Thumbnail" className="w-28 h-16 md:w-36 md:h-20 object-cover rounded-xl border border-white/10 shadow-lg shrink-0" />
          ) : (
            <span className="w-14 h-14 rounded-xl border border-purple-400/30 bg-purple-500/10 text-purple-300 flex items-center justify-center shrink-0">
              <FileText className="w-6 h-6" strokeWidth={1.75} />
            </span>
          )}
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-muted flex items-center gap-1.5">
              {vm ? <Youtube className="w-3.5 h-3.5 text-pink-400" /> : null}
              {vm ? "Video analizado" : "Guion analizado"}
            </p>
            <h2 className="text-base md:text-lg font-bold text-gray-900 truncate">{vm?.title || "Informe de análisis con IA"}</h2>
            {vm && (
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-brand-text2 mt-1">
                <span className="truncate">Canal: {vm.channel}</span>
                <span className="inline-flex items-center gap-1"><Eye className="w-3.5 h-3.5 text-cyan-300" />{formatNumber(vm.view_count)}</span>
                <span className="inline-flex items-center gap-1"><ThumbsUp className="w-3.5 h-3.5 text-purple-300" />{formatNumber(vm.like_count)}</span>
                <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-pink-300" />{formatDuration(vm.duration)}</span>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 md:gap-3 lg:justify-end">
          <button data-testid="new-analysis-button" onClick={onReset} className="vt-btn-secondary text-sm px-4 py-2">
            <RotateCcw className="w-4 h-4" />
            {shareMode ? "Analizar mi propio video" : "Nuevo Análisis"}
          </button>
          {!shareMode && user && <ShareButtons analysis={analysis} />}
          <button data-testid="download-pdf-button" onClick={onDownloadPdf} className="vt-btn-primary text-sm px-4 py-2">
            <Download className="w-4 h-4" />
            Descargar PDF
          </button>
          <button data-testid="share-button" onClick={onShare} className="vt-btn-secondary text-sm px-4 py-2">
            {copied ? (<><Check className="w-4 h-4 text-emerald-300" />¡Enlace copiado!</>) : (<><Share2 className="w-4 h-4" />Compartir</>)}
          </button>
        </div>
      </div>
    </div>
  );
}
